import React from "react";
import { StepConditionScheduleReserveContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import { HeaderBackMusicHallWidget } from "widgets";
import { Buttons, Displays, Headers, Navigations } from "components";

class StepConditionScheduleReserveContainer extends React.Component {
  handleGoBack = () => {
    const { conditionStep, router } = this.props;
    const { id } = router.params;
    this.props.router.navigate(
      conditionStep === 2
        ? `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/condition/1${router.location.search}`
        : `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/rental/2${router.location.search}`,
    );
  };

  handleNextStep = () => {
    const { conditionStep, router } = this.props;
    const { id } = router.params;
    this.props.router.navigate(
      conditionStep === 2
        ? `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/3${router.location.search}`
        : `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/condition/2${router.location.search}`,
    );
  };

  render() {
    const { conditionStep, i18n, router, t } = this.props;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Hall Bangkok", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
      },
    ];
    return (
      <StepConditionScheduleReserveContainerStyled isPreview={isPreview}>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="step_condition_schedule_reserve_container">
          {!isPreview ? (
            <div className="header_layout mb_0">
              <Headers.NewPageHeader
                title={"YAMAHA MUSIC  HALL, BANGKOK"}
                sub_title={"Rental Registration form "}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicHallWidget room_booking_id={router.params.id} />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="body_layout">
            <Displays.ImageSmooth
              src={`/assets/images/backgrounds/music-hall-condition${conditionStep}_${
                i18n.language === "en" ? "en" : "th"
              }.png`}
              alt="music_hall_condition"
              aspectRatio="2520 / 4480"
            />
          </div>
          <div className="button_layout">
            <div className="button1">
              <Buttons.BgStandard
                theme_white_purple
                label={t("Back", { ns: "common" })}
                onClick={this.handleGoBack}
              />
            </div>
            <div className="button2">
              <Buttons.BgStandard
                theme_white_purple={isPreview}
                label={t("Next", { ns: "common" })}
                onClick={this.handleNextStep}
              />
            </div>
          </div>
        </div>
      </StepConditionScheduleReserveContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(
  withRouter(StepConditionScheduleReserveContainer),
);
